import { Box, BoxProps, Paper } from "@mui/material";

export default (props : BoxProps) => {
	return (
		<Paper>
			<Box p={2} py={2.25} {...props} />
		</Paper>
	);
}
